module.exports = __webpack_public_path__ + "media/images/badges/akt/milestone-3-Inactive-AKT-707ae18e5d9edd4c51c11a648450f0a9.png";